import script from "./TopUserMarkers.vue?vue&type=script&setup=true&lang=js"
export * from "./TopUserMarkers.vue?vue&type=script&setup=true&lang=js"

import "./TopUserMarkers.vue?vue&type=style&index=0&id=3b6ed76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6ed76c"]])

export default __exports__